import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @qcx/prefer-arrow-functions */
/* eslint-disable @qcx/no-invalid-use-effect */
/* eslint-disable no-restricted-imports */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @qcx/no-invalid-filename
import merge from 'deepmerge';
import { createContext, startTransition, useContext, useEffect, useMemo, useRef } from 'react';
import { createWithEqualityFn as zustandCreateStore, useStoreWithEqualityFn as zustandUseStore } from 'zustand/traditional';
export function createStore(initialState, actionsCreator) {
    const Context = createContext(null);
    const createStoreWithInitialState = (providerInitialState) => {
        const _onMountCallbacks = [];
        const _onDestroyCallbacks = [];
        const state = providerInitialState
            ? merge(initialState, providerInitialState)
            : initialState;
        const onMount = (callback) => {
            _onMountCallbacks.push(callback);
        };
        const onDestroy = (callback) => {
            _onDestroyCallbacks.push(callback);
        };
        return zustandCreateStore((set, get, store) => {
            const dispatch = (actionName, ...params) => {
                const state = get();
                const action = state[actionName];
                if (action === undefined) {
                    throw new TypeError(`Action "${actionName}" not found`);
                }
                return action.bind(state)(...params);
            };
            const { subscribe, destroy } = store;
            return {
                ...state,
                ...actionsCreator({
                    set,
                    get,
                    subscribe,
                    destroy,
                    dispatch,
                    initialState: state,
                    providerInitialState,
                    onMount,
                    onDestroy
                }),
                _onMountCallbacks,
                _onDestroyCallbacks
            };
        });
    };
    const Provider = ({ initialState: providerInitialState, children }) => {
        const providerResolvedInitialState = useMemo(() => providerInitialState
            ? Object.fromEntries(Object.entries(providerInitialState)
                .filter(([, value]) => {
                return typeof (value === null || value === void 0 ? void 0 : value.then) !== 'function';
            })
                .map(([key, value]) => [key, value]))
            : providerInitialState, [providerInitialState]);
        const storeRef = useRef(createStoreWithInitialState(providerResolvedInitialState));
        useEffect(() => {
            startTransition(() => {
                if (!storeRef.current || !providerInitialState) {
                    return;
                }
                for (const [key, value] of Object.entries(providerInitialState).filter(([, value]) => {
                    return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
                })) {
                    (async () => {
                        const resolvedValue = await value;
                        storeRef.current.setState({
                            [key]: resolvedValue
                        });
                    })();
                }
            });
        }, [providerInitialState]);
        useEffect(() => {
            startTransition(() => {
                if (!storeRef.current || !providerResolvedInitialState) {
                    return;
                }
                const { getState, setState } = storeRef.current;
                const currentState = getState();
                const keys = Object.keys(providerResolvedInitialState);
                const prevState = pick(currentState, keys);
                const nextState = providerResolvedInitialState;
                const hasChanges = JSON.stringify(deepSortKeys(prevState)) !==
                    JSON.stringify(deepSortKeys(nextState));
                if (!hasChanges) {
                    return;
                }
                setState(merge(currentState, nextState, {
                    arrayMerge: overwriteMerge
                }));
            });
        }, [providerResolvedInitialState]);
        useMounted(() => {
            if (!storeRef.current) {
                return;
            }
            const { getState } = storeRef.current;
            // Call mount callbacks
            for (const callback of getState()._onMountCallbacks) {
                callback();
            }
            return () => {
                // Call destroy callbacks
                for (const callback of getState()._onDestroyCallbacks) {
                    callback();
                }
            };
        });
        return (_jsx(Context.Provider, { value: storeRef.current, children: children }));
    };
    const useStore = function (selector, equalityFn) {
        const store = useContext(Context);
        return zustandUseStore(store, selector, equalityFn);
    };
    Provider.displayName = 'StoreProviderWatcher';
    return { Provider, useStore };
}
const overwriteMerge = (_target, source) => {
    return source;
};
const useMounted = (cb) => {
    const mountedRef = useRef(false);
    useEffect(() => {
        if (mountedRef.current) {
            return;
        }
        const destroyCb = cb.call(null);
        mountedRef.current = true;
        return () => {
            if (typeof destroyCb === 'function') {
                destroyCb();
            }
            mountedRef.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const pick = (obj, keys) => {
    return keys.reduce((memo, key) => {
        memo[key] = obj[key];
        return memo;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
    }, {});
};
const deepSortKeys = (obj) => {
    const sorted = {};
    for (const key of Object.keys(obj).sort()) {
        sorted[key] =
            obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])
                ? deepSortKeys(obj[key])
                : obj[key];
    }
    return sorted;
};
export { shallow } from 'zustand/shallow';
